<script setup>
import { onMounted, ref } from 'vue'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import Translator from '@/shared/utils/translator'
gsap.registerPlugin(ScrollTrigger)

const menuOpen = ref(false)
const headerContainer = ref(null)
const header = ref(null)

const menuItems = [
  { label: 'Accueil', to: '/', routeName: 'home', icon: '' },
  { label: 'Formations', to: '/formations', routeName: 'formations', icon: '' },
  { label: 'A propos', to: '/a-propos', routeName: 'about', icon: '' },
  { label: 'Coaching', to: '/coaching', routeName: 'coaching', icon: '' },
]

onMounted(() => {
  gsap
    .timeline({
      scrollTrigger: {
        trigger: headerContainer.value,
        start: 'top top',
        end: '+=300', // ou selon la distance souhaitée
        scrub: true,
      },
    })

    .to(header.value, {
      borderColor: '#00000009',
      backgroundColor: '#FFFF',
    })
})
</script>

<template>
  <div class="absolute" ref="headerContainer">
    <div
      class="header w-full title-color fixed top-0 z-40 border-b border-[#0000] bg-[#fff0] rouned-full"
      ref="header"
    >
      <header class="header py-4 px-4 2xl:py-4 w-full title-color">
        <div class="container">
          <div class="flex items-center justify-between">
            <router-link
              to="/"
              class="flex items-end gap-1 relative -left-2 items-center"
            >
              <div class="h-12 w-12 min-w-12">
                <img src="/images/logo.png" class="h-full" alt="" />
              </div>
              <div class="text-2xl md:text-3xl font-bold">
                {{ $t('app.appName') }}
              </div>
            </router-link>
            <!-- Hamburger button for mobile -->
            <button
              class="md:hidden flex flex-col justify-center items-center w-10 h-10 focus:outline-none group"
              @click="menuOpen = !menuOpen"
              aria-label="Ouvrir le menu"
            >
              <span
                :class="[
                  'block w-7 h-0.5 bg-current mb-1 transition-all duration-300',
                  menuOpen ? 'rotate-45 translate-y-2' : '',
                ]"
              ></span>
              <span
                :class="[
                  'block w-7 h-0.5 bg-current mb-1 transition-all duration-300',
                  menuOpen ? 'opacity-0' : '',
                ]"
              ></span>
              <span
                :class="[
                  'block w-7 h-0.5 bg-current transition-all duration-300',
                  menuOpen ? '-rotate-45 -translate-y-2' : '',
                ]"
              ></span>
            </button>
            <!-- Desktop menu -->

            <div class="hidden md:flex gap-8 text-lg">
              <router-link
                v-for="item in menuItems"
                :key="item.to"
                class="font-bold"
                :to="item.to"
                analytic-click
                :class="{
                  hidden: $route.name === item.routeName,
                }"
              >
                {{ item.label }}
              </router-link>
            </div>
          </div>
          <!-- Mobile menu -->
        </div>
      </header>
      <transition name="slide-fade">
        <div
          v-if="menuOpen"
          class="md:hidden left-0 top-full w-full border-[#0000] title-color z-50 border-gray-400 animate-fade-in overflow-hiddn rounded-b-2xl duration-300"
        >
          <div class="flex flex-col gap-4 p-8 pt-4 text-lg font-bold">
            <router-link
              v-for="item in menuItems"
              :key="item.to"
              :to="item.to"
              analytic-click
              @click.native="menuOpen = false"
              :class="{
                hidden: $route.name === item.routeName,
              }"
              class="rounded-xl px-4 py-3 hover:bg-primary hover:text-white transition-colors duration-200"
            >
              <span class="flex items-center gap-2">
                <!-- <span v-if="item.icon" class="text-xl">{{ item.icon }}</span> -->
                {{ item.label }}
              </span>
            </router-link>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.slide-fade-enter-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.slide-fade-enter-from {
  opacity: 0;
  transform: translateY(-20px);
}
.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>
